export class ProviderSubscriptionUpdateRequest {
  assignedSeats: number;
}
